import dataConfig from '../../baseConfig/dataConfig';

const state = () => ({
    loadedLanguages: [],
    userRefreshStamp: 0,
    isDemo: false,
    gameId: 1,
    isBanVisit: true,
    payType: { type: ["bank"], parnter: dataConfig.CASH_PARTNERS.EP }
})


// getters
const getters = {
    isRefreshUser: state => {
        let now = Math.floor((new Date()).getTime() / 1000);
        let last = state.userRefreshStamp;
        !last && (last = 0)
        let rlt = (now - last) > 15 ? true : false;
        console.log(now + " - " + last + " = " + (now - last));
        return rlt;
    },
    isDemo: state => {
        return state.isDemo;
    }
}

// actions
const actions = {
}

// mutations
const mutations = {
    setPayType(state, data) {
        //同步枚举值
        if (data.parnter) {
            for (let key in dataConfig.CASH_PARTNERS) {
                if (dataConfig.CASH_PARTNERS[key].toLowerCase() == data.parnter) {
                    data.parnter = dataConfig.CASH_PARTNERS[key];
                    break;
                }
            }
        }
        state.payType = data;
    },
    pushLanguage(state, id) {
        state.loadedLanguages.push(id)
    },
    setUserRefreshStamp(state, data) {
        state.userRefreshStamp = Math.floor((new Date()).getTime() / 1000);
    },
    setIsDemo(state, data) {
        state.isDemo = data;
    },
    setGameId(state, id) {
        state.gameId = id;
    },
    setIsBanVisit(state, data) {
        state.isBanVisit = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/temp.js